import React from 'react';
import Scene from 'containers/Scene';

const Editor = ({ loading }) => {
  if (loading) return null;
  return !loading && <Scene />;
};

export default Editor;
